import { getLoggedUserData } from '@/components/@analitycs/get-logged-user-data'

export interface EcommerceEventItem {
  id: string
  name: string
  price: number
  quantity: number
}

export interface EnhancedMatchUserData {
  email?: string
  phone?: string
  firstName?: string
  lastName?: string
  city?: string
  state?: string
  zip?: string
  country?: string
}

export async function buildGA4EventModel({
  currency,
  value,
  transactionId,
  coupon,
  searchTerm,
  items,
  userData,
}: {
  currency?: string
  value?: number
  transactionId?: string
  coupon?: string
  searchTerm?: string
  items?: EcommerceEventItem[]
  userData?: EnhancedMatchUserData
}) {
  const ga4Items = items?.map(item => ({
    item_id: item.id,
    item_name: item.name,
    price: item.price,
    quantity: item.quantity,
  }))

  const resolvedUserData = userData ?? (await getLoggedUserData())

  return {
    currency,
    value,
    transaction_id: transactionId,
    search_term: searchTerm,
    coupon,
    items: ga4Items,
    user_data: resolvedUserData && {
      email: resolvedUserData.email,
      phone_number: resolvedUserData.phone,
      address: {
        first_name: resolvedUserData.firstName,
        last_name: resolvedUserData.lastName,
        city: resolvedUserData.city,
        region: resolvedUserData.state,
        postal_code: resolvedUserData.zip,
        country: resolvedUserData.country,
      },
    },
  }
}
